import React from "react";
import { Card, CardContent, CardActions, Typography } from "@material-ui/core";

const PlanCard = ({
  plan,
  cardStyle = {},
  titlePrefix = null,
  children = null,
}) => {
  return (
    <Card style={cardStyle}>
      <CardContent>
        <Typography variant="h5" component="h2">
          {titlePrefix}
          {plan["Title"]}
        </Typography>
        <Typography
          component="p"
          style={{ whiteSpace: "pre-line" }}
          dangerouslySetInnerHTML={{ __html: plan["Description"] }}
        />
      </CardContent>
      {children ? <CardActions>{children}</CardActions> : null}
    </Card>
  );
};

export default PlanCard;
